import { render } from "./CategoryLabel.vue?vue&type=template&id=4a9e4d06"
import script from "./CategoryLabel.vue?vue&type=script&lang=js"
export * from "./CategoryLabel.vue?vue&type=script&lang=js"

import "./CategoryLabel.vue?vue&type=style&index=0&id=4a9e4d06&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__